import { useQuery } from '@shared/modules/use-query/hooks'
import { ProductCategory } from '../types/categories'
import { useCallback, useMemo } from 'react'
import { ProductCategoriesService } from '../services/categories'

export const useProductCategoryList = () => {
  return useQuery<ProductCategory[]>(
    useCallback(async () => {
      const result = await ProductCategoriesService.getAll({ page: 1, per_page: 5000 })
      if (result.status === 200) {
        return result.data
      } else {
        throw new Error(result.data)
      }
    }, []),
    useMemo(() => ({ initialData: [] }), []),
  )
}
